module.exports = __webpack_public_path__ + "img/boy-and-dog_gif_gray.bee3add8.gif";